import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { getClubMembers } from "@/app/api/dynabuy-back/api-club";
import { ClubMembersReadOptions, MemberRead } from "@/TS/Interfaces/global_interfaces";
const CLUB_MEMBERS_STALE_TIME_MS = 10 * 60 * 1000; // 10 minutes

export function useClubMembers(clubSlug, options, t0) {
  const $ = _c(8);
  const enabled = t0 === undefined ? true : t0;
  let t1;
  let t2;
  if ($[0] !== clubSlug || $[1] !== options) {
    t1 = ["club-members", clubSlug, options];
    t2 = () => getClubMembers(clubSlug, options);
    $[0] = clubSlug;
    $[1] = options;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  const t3 = enabled && !!clubSlug;
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3,
      staleTime: CLUB_MEMBERS_STALE_TIME_MS
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return useQuery(t4);
}